import { useWindowDimensions } from 'react-native'

import { MOBILE_BREAKPOINT } from '@/lib'

export const useIsMobileScreen = () => {
  const { width } = useWindowDimensions()

  return width < MOBILE_BREAKPOINT
}
